function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-532.878 -89.201)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M541.123,108.171c-1.684,0-3.368.006-5.052,0A3.238,3.238,0,0,1,532.884,105c-.009-2.557.005-5.114-.006-7.672a3.328,3.328,0,0,1,1.882-3.064,1.38,1.38,0,0,0,.6-.682,5.977,5.977,0,0,1,11.53.045,1.181,1.181,0,0,0,.518.6,3.363,3.363,0,0,1,1.951,3.15c-.018,2.5,0,4.99-.006,7.485a3.244,3.244,0,0,1-3.3,3.309Q543.587,108.174,541.123,108.171Zm0-1.73c1.705,0,3.41.007,5.115,0a1.234,1.234,0,0,0,1.382-1.39q.013-3.96,0-7.921a1.277,1.277,0,0,0-1.422-1.435q-5.084-.021-10.167,0a1.275,1.275,0,0,0-1.412,1.444q-.01,3.93,0,7.859c0,.992.454,1.44,1.453,1.445C537.754,106.447,539.438,106.441,541.122,106.441Zm4.01-12.506a3.994,3.994,0,0,0-4.4-2.994c-1.773.115-3.515,1.57-3.561,2.994Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542.243,101.748c0,.526.022,1.055-.005,1.579a1.132,1.132,0,1,1-2.238-.009c-.029-1.051-.029-2.106,0-3.158a1.2,1.2,0,0,1,1.12-1.288c.605,0,1.064.531,1.123,1.3,0,.052,0,.105,0,.157,0,.474,0,.948,0,1.422Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.875,
  cy: 1.875,
  r: 1.875,
  transform: "translate(539.24 97.497)"
}));

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2cbbdb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.484,
    height: 18.972,
    viewBox: "0 0 16.484 18.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ff531ba215746bba6ee62fd6bf919842.svg";
export { ForwardRef as ReactComponent };